/** Rutas de audiencia Empresas (provisional; fácil de renombrar). */
export const EMPRESAS_HOME = "/empresas";
export const EMPRESAS_ENERGIA = "/empresas/ecco-energia";
export const EMPRESAS_CONSULTORIO = "/empresas/consultorio-in-company";
export const EMPRESAS_AUSENTISMO = "/empresas/control-de-ausentismo";
export const EMPRESAS_CAPACITACION = "/empresas/capacitacion";
export const EMPRESAS_SALVAMENTO = "/empresas/primer-salvamento";
export const EMPRESAS_EVENTOS = "/empresas/cobertura-de-eventos";
export const EMPRESAS_TRASLADOS = "/empresas/traslados";
export const EMPRESAS_LABORAL = "/empresas/medicina-laboral";
export const EMPRESAS_CUIDADOS = "/empresas/cuidados-domiciliarios";
export const EMPRESAS_AREA_PROTEGIDA = "/empresas/area-protegida";

/** Rutas de audiencia Familias (bajo basename /individuales → URL /individuales/familias). */
export const FAMILIAS_HOME = "/familias";
export const FAMILIAS_CUIDADOS = "/familias/cuidados-domiciliarios";
export const FAMILIAS_TRASLADOS = "/familias/traslados";

export const INFO_UTIL = "/informacion-util";
export const LINEA_DENUNCIAS = "/linea-denuncias";
export const DATOS_IMPOSITIVOS = "/datos-impositivos";

export const COTIZADOR_FAMILIA = "/productos/consulta";
export const COTIZADOR_EMPRESA = "/productos/consulta/empresa";

/** Slug del cotizador corporativo según la landing de producto. */
const CORPORATE_LANDING_SLUG = {
  [EMPRESAS_AUSENTISMO]: "control-de-ausentismo",
  [EMPRESAS_AREA_PROTEGIDA]: "area-protegida",
  [EMPRESAS_SALVAMENTO]: "emergencias-y-urgencias",
  [EMPRESAS_CUIDADOS]: "cuidados-domiciliarios",
  [EMPRESAS_CONSULTORIO]: "consultorio-in-company",
  [EMPRESAS_LABORAL]: "medicina-laboral",
  [EMPRESAS_EVENTOS]: "cobertura-de-eventos",
  [EMPRESAS_CAPACITACION]: "capacitacion",
  [EMPRESAS_TRASLADOS]: "traslados",
  [EMPRESAS_ENERGIA]: "ecco-energia",
};

export const cotizadorEmpresaServicio = slug => `${COTIZADOR_EMPRESA}/${slug}`;

export const cotizadorPathFromLocation = pathname => {
  if (!pathname) {
    return COTIZADOR_FAMILIA;
  }
  if (CORPORATE_LANDING_SLUG[pathname]) {
    return cotizadorEmpresaServicio(CORPORATE_LANDING_SLUG[pathname]);
  }
  if (pathname === EMPRESAS_HOME || pathname.startsWith(`${EMPRESAS_HOME}/`)) {
    return COTIZADOR_EMPRESA;
  }
  if (pathname === COTIZADOR_EMPRESA) {
    return COTIZADOR_EMPRESA;
  }
  if (pathname.startsWith(`${COTIZADOR_EMPRESA}/`)) {
    return pathname;
  }
  return COTIZADOR_FAMILIA;
};
